import { RequestContext } from "../request-context";

export enum SettingsContentTypes {
    GetPaymentSettingsOutput = 'atv.wps#GetPaymentSettingsOutput',
    GetSubtitlesSettingsOutput = 'atv.wps#GetSubtitlesSettingsOutput',
    GetDevicesSettingsOutput = 'atv.wps#GetDevicesSettingsOutput',
    NavigationTabsOutput = 'atv.wps#NavigationTabsOutput',
    GetAutoplaySettingsOutput = 'atv.wps#GetAutoplaySettingsOutput',
    GetInvoicesOutput = 'atv.wps#GetInvoicesOutput',
    GetInvoiceHistoryOutput = 'atv.wps#GetInvoiceHistoryOutput',
    GetMembershipsOutput = 'atv.wps#GetMembershipsOutput',
    GetLanguageSettingsOutput = 'atv.wps#GetLanguageSettingsOutput',
    PageTitleOutput = 'atv.wps#PageTitleOutput',
    PaymentUpgradeOutput = 'atv.wps#PaymentUpgradeOutput',
    AccountDetailsOutput = 'atv.wps#AccountDetailsOutput',
    DoubleBillingOutput = 'atv.wps#DoubleBillingOutput',
    MembershipPaymentWidgetOutput = 'atv.wps#MembershipPaymentWidgetOutput',
    SubscriptionsOutput = 'atv.wps#SubscriptionsOutput',
    ConfirmCancelOutput = 'atv.wps#ConfirmCancelOutput',
    GetPinOnPurchaseSettingsOutput = 'atv.wps#GetPinOnPurchaseSettingsOutput',
    GetPinSettingsOutput = 'atv.wps#GetPinSettingsOutput',
    GetViewingRestrictionsOutput = 'atv.wps#GetViewingRestrictionsOutput',
    ParentalControlsSettingsOutput = 'atv.wps#ParentalControlsSettingsOutput',
    // 3 different views of Pin widget
    PinWidgetTeen = 'atv.wps#PinWidgetTeen',
    PinWidgetFSK18 = 'atv.wps#PinWidgetFSK18',
    PinWidgetStandard = 'atv.wps#PinWidgetStandard',
    // 3 different views of ViewingRestrictions widget
    ViewingRestrictionsWidgetTeen = 'atv.wps#ViewingRestrictionsWidgetTeen',
    ViewingRestrictionsWidgetPinNotSet = 'atv.wps#ViewingRestrictionsWidgetPinNotSet',
    ViewingRestrictionsWidgetStandard = 'atv.wps#ViewingRestrictionsWidgetStandard',
    // empty widget for graceful fallback
    EmptyWidget = 'atv.wps#EmptyContent',
    WatchHistoryOutput = 'atv.wps#WatchHistoryOutput'
}

export enum SettingsWidgetType {
    NavigationTabsWidget = 'navigation-tabs',
    PageTitleWidget = 'page-title',
    PaymentUpgradeWidget = 'payment-upgrade',
    AccountDetailsWidget = 'account-details',
    MembershipPaymentWidget = 'membership-payment',
    ConfirmCancelWidget = 'confirm-cancel',
    DoubleBillingWidget = 'double-billing',
    SubscriptionsWidget = 'subscriptions',
    PVInvoiceHistoryWidget = 'pv-invoice-history',
    AutoplayWidget = 'autoplay',
    PaymentHistoryWidget = 'payment-history',
    ChannelsInvoiceHistoryWidget = 'channels-invoice-history',
    ChannelsMembershipsWidget = 'channels-memberships',
    DevicesWidget = 'devices',
    LanguagesWidget = 'languages',
    SubtitlesWidget = 'subtitles',
    PaymentWidget = 'payment',
    PinOnPurchaseWidget = 'pin-on-purchase',
    PinWidget = 'pin',
    ViewingRestrictionsWidget = 'viewing-restrictions',
    ParentalControlsWidget = 'parental-controls',
    WatchHistoryWidget = 'watch-history'
}

export enum SettingsSubPage {
    YourAccount = 'your-account',
    Channels = 'channels',
    Playback = 'playback',
    ParentalControls = 'parental-controls',
    Subtitles = 'subtitles',
    YourDevices = 'your-devices',
    Language = 'language',
    WatchHistory = 'watch-history',
    PaymentHistory = 'payment-history'
}

export interface SettingsContent {
    __type: SettingsContentTypes;
}

export interface EmptyContent extends SettingsContent {
    __type: SettingsContentTypes.EmptyWidget
}

export interface SettingsResult {
    widgetType: SettingsWidgetType;
    content: SettingsContent;
}

export interface SettingsWidgetArgs {
    ubid?: string;
    authToken?: string;
    isPurchaseRow?: boolean;
    isChannelsRow?: boolean;
    currentPage?: number;
}

export interface SettingsInput {
    context: RequestContext;
    subPage?: SettingsSubPage;
    widgets?: SettingsWidgetType[];
     // widgetArgs is either
     //  - a JSON string with format of SettingsWidgetArgs (when request is made from clientside to Gurupa);
     //  or
     //  - a SettingsWidgetArgs object (when request is made from DevServer/WidgetServer to WPS directly)
     widgetArgs: string | SettingsWidgetArgs;
}

export interface SettingsOutput {
    notifications: SettingsResult[];
    widgets: SettingsResult[];
}
